<template>
  <div class="animated fadeIn">

    <b-row style="border: 1px dashed black;margin:10px">
      <b-col style="padding: 10px">
        <form enctype="multipart/form-data">
        <!-- <h1>Upload images</h1> -->
        <!-- <div class="dropbox"> -->
          <input type="file" @change="fileChange($event.target.files)" accept=".csv,.CSV,.xls,.XLS,.xlsx,.XLSX">
            <!-- <p v-if="isInitial">
              Drag your file(s) here to begin<br> or click to browse
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p> -->
        <!-- </div> -->
        <button type="button" @click="uploadFile()">Upload</button>
      </form>
      </b-col>
    </b-row>

    <MyModal v-if="showUploadingModal" v-on:close="closeUploadingModal()" headerTitle="Uploading..." bodyMessage="Please wait"/>

  <MyModal v-if="showUploadingSuccessModal" v-on:close="closeUploadSuccessModal()" headerTitle="Success" bodyMessage="Upload Success."/>
  <MyModal v-if="showUploadingFailedModal" v-on:close="closeUploadFailModal()" headerTitle="Failed" bodyMessage="Upload Failed."/>


  <div class="row">
        <div class="col">
          <span> Rows Per Page:</span>
          <!-- <input v-model="rowsPerPageC" type="number"/> -->
          <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1">
            <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="col" align="center">
          <b-pagination 
            size="sm" 
            :total-rows="totalRowsC" 
            v-model="currentPage" 
            :per-page="rowsPerPageC" 
            hide-ellipsis
            :limit="paginationButtonsLimit" 
            align="center"
            @change="pageChanged"
            >
        </b-pagination>
        </div>
        <div class="col" align="right">
            <span>Total Rows {{totalRowsC}}</span>  
          </div>
      </div>
      
      <br/>
      <button type="button" class="btn btn-primary" @click="refreshTable()">Refresh</button>
      <b-table small bordered hover :items="tableRows" :fields="tableHeaders"
        @row-clicked="tableRowClicked" id="uploadedInvoicesTable">
        <template slot="cell(status)" slot-scope="row">
          <span>{{row.item.status}}</span>
          <button type="button" v-if="row.item.status == 'NEW'" class="btn btn-primary" @click="importFile(row.item.docId, row.item.fileName, row.item.status)">Import</button>
        </template>
      </b-table>

      <img src="static/img/Rolling.svg" alt="Loading data..." 
      style="margin-left:auto; margin-right:auto; display: block;"
      v-if="showLoadingAnimation">
    <p style="text-align: center"
      v-if="showLoadingError">
    Loading error:
    </p>
    <p style="text-align: center"
      v-if="showNoResult">
    No Result
    </p>

    <MyModal v-if="showImportingModal" v-on:close="closeImportingModal()" headerTitle="Importing..." bodyMessage="Do not navigate away from this screen, import should not take more than 9 minutes, please wait..."/>

    <MyModal v-if="showImportingSuccessModal" v-on:close="closeImportSuccessModal()" headerTitle="Success" bodyMessage="Import Completed."/>
    <MyModal v-if="showImportingFailedModal" v-on:close="closeImportFailModal()" headerTitle="Failed" :bodyMessage="importFailedMessage"/>

  </div>
</template>

<script>
import { MyModal } from '../components/'
export default {
  name: 'invoiceupload',
  components: {
    MyModal
  },
  data () {
    return {
      fileToUpload: null,
      currentPage: 1,
      paginationButtonsLimit: 3
    }
  },
  created: function () {
    this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' })
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 2) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 2) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    fileChange: function (files) {
      for (let eachFile of files) {
        console.log('file name: ' + eachFile.name)
        console.log('file size: ' + eachFile.size + 'bytes')
        console.log('file type: ' + eachFile.type)
        // console.log('Prop: ' + prop + ' value: ' + event.prop)
        this.fileToUpload = eachFile
      }
    },
    uploadFile: function () {
      this.$store.dispatch('iumod/uploadFileToFirebaseStorage', {file: this.fileToUpload})
    },
    closeUploadingModal: function () {
      this.$store.commit('iumod/toggleUploadingModal', false)
    },
    closeUploadSuccessModal: function () {
      this.$store.commit('iumod/toggleUploadingSuccessModal', false)
      this.fileToUpload = null
    },
    closeUploadFailModal: function () {
      this.$store.commit('iumod/toggleUploadingFailedModal', false)
    },
    closeImportingModal: function () {
      // this.$store.commit('iumod/toggleImportingModal', false)
    },
    closeImportSuccessModal: function () {
      this.$store.commit('iumod/toggleImportingSuccessModal', false)
    },
    closeImportFailModal: function () {
      this.$store.commit('iumod/toggleImportingFailedModal', false)
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.iumod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('iumod/changePageNumber', this.currentPage)
        this.$store.commit('iumod/setRowsPerPage', intRows)
        this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' })
      }
    },
    importFile: function (docId, filename, status) {
      // console.log('Start import file: ' + downloadURL)
      this.$store.dispatch('iumod/importFile', { docId: docId, filename: filename, status: status })
    },
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('iumod/changePageNumber', this.currentPage)
      this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' })
    },
    refreshTable: function () {
      this.currentPage = 1
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.dispatch('iumod/showAllUploads', { orderBys: 'uploadedDate' })
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked, index:' + index + ' item:' + item + ' event:' + event)
      // for (let i in item) {
      //   console.log('i:' + i)
      // }
      this.$store.commit('iumod/selectTableRow', item.docId)
      this.selectedRowItem = item
    }
  },
  computed: {
    uploadFileName: function () {
      return this.$store.state.iumod.uploadFileName
    },
    showUploadingModal: function () {
      return this.$store.state.iumod.showUploadingModal
    },
    showUploadingSuccessModal: function () {
      return this.$store.state.iumod.showUploadingSuccessModal
    },
    showUploadingFailedModal: function () {
      return this.$store.state.iumod.showUploadingFailedModal
    },
    showImportingModal: function () {
      return this.$store.state.iumod.showImportingModal
    },
    showImportingSuccessModal: function () {
      return this.$store.state.iumod.showImportingSuccessModal
    },
    showImportingFailedModal: function () {
      return this.$store.state.iumod.showImportingFailedModal
    },
    importFailedMessage: function () {
      return this.$store.state.iumod.importFailedMessage
    },
    tableRows: function () {
      return this.$store.state.iumod.all
    },
    tableHeaders: function () {
      return this.$store.getters['iumod/getHeaders']
    },
    uploadingMessage: function () {
      return 'Please wait' + this.$store.state.iumod.uploadProgress
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.iumod.rowsPerPage
    },
    totalRowsC: function () {
      return this.$store.state.iumod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.iumod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('iumod/setRowsPerPage', newValue)
      }
    },
    showLoadingAnimation: function () {
      return this.$store.state.iumod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.iumod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.iumod.showNoResult
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/InvoiceUpload.vue